import { render, staticRenderFns } from "./MonitorarProcessamento.vue?vue&type=template&id=64b705b2&lang=pug"
import script from "./MonitorarProcessamento.vue?vue&type=script&lang=js"
export * from "./MonitorarProcessamento.vue?vue&type=script&lang=js"
import style0 from "./MonitorarProcessamento.vue?vue&type=style&index=0&id=64b705b2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports